export const UserRels = {
    GetMyProfile: 'getMyProfile'
};
